import { useSelector } from 'react-redux'
import ConditionalRender from '../../../../ConditionalRender.js'
import Icons from '../../../../design_system/components/Icons/Icons.jsx'
import { Button } from '../../../../design_system/components/Button/Button.jsx'

const SecFilingAlert = (props) => {
    const { tab } = props
    const current_team = useSelector(state => state.current_team.team)

    if (!current_team.sec_filings_trial) return null;
    return (
        <>
            <div className={`flex flex-col gap-s p-xl sec-filing-alert ${tab === "All" ? "sec-filing-alert--all-tab" : "sec-filing-alert--feed-tab"}`}>
                <ConditionalRender if={current_team.sec_filings_trial}>
                    <div className="label-s sec-filing-alert__badge px-m py-2xs">New Feature</div>
                </ConditionalRender>
                <div>
                    <div className="body-l-bold sec-filing-alert__title mb-xs">SEC Filing alerts — Now on AlmaConnect News</div>
                    <div className="body-s sec-filing-alert__description">Track 10-K, 10-Q, 8-K filings and insider transactions for your prospects in real time. Get notified when a prospect makes a material disclosure — right here in your
                        newsfeed.</div>
                </div>
                <a href="https://cal.com/almaconnect/sec-alerts" target="_blank" className="body-s-bold sec-filing-alert__cta">
                    <Button Type="Secondary" Size="Small">
                        {tab === "All" ? "Learn More" : (
                            <span className="flex items-center gap-xs">
                                Talk to our team <Icons name="right-arrow" size={16} />
                            </span>
                        )}
                    </Button>
                </a>
            </div>
            <ConditionalRender if={tab === 'Sec_Filings' && current_team.sec_filings_trial}>
                <div className="flex flex-col gap-xs sec-filing-alert__trial px-l py-s">
                    <div className="body-s-bold sec-filing-alert__trial-label">You're on a free trial.
                        <span className="body-m sec-filing-alert__trial-days"> {current_team.sec_filing_trial_days_left} </span>
                        days remaining.
                    </div>
                    <div className="body-s-semibold sec-filing-alert__trial-cta">Upgrade to keep access to SEC Filings in your feed.</div>
                </div>
            </ConditionalRender>
        </>
    )
}

export default SecFilingAlert
